module.exports = __webpack_public_path__ + "img/技术支持.a0457f59.png";